<template>
<div class="search-wrap">
    <div
        class="click-icon search_icon"
        @click="searchShow = true"></div>
    <el-drawer
        :append-to-body="true"
        class="search-drawer"
        title="查询"
        :visible.sync="searchShow"
        :size="400">
        <template v-for="item in searchForm">
            <div
                class="filter-item"
                v-if="item.key !== 'projectId'"
                :key="item.key">
                <div class="label">
                    <span v-if="item.required" class="required">*</span>
                    {{item.label}}：
                </div>
                <el-input
                    v-if="item.type === 'input'"
                    v-model="filter[item.key]"
                    :placeholder="item.placeholder"
                    size='small'></el-input>
                <el-select
                    filterable
                    v-if="item.type === 'select'"
                    :remote="item.remote === true"
                    :remote-method="(query) => remote(query,item)"
                    v-model="filter[item.key]"
                    @change="update(item)"
                    @focus="selectFocus(item)"
                    :placeholder="item.placeholder"
                    :clearable="item.required != true"
                    size='small'>
                    <el-option
                        v-for="op in data[item.data]"
                        :key="op[item.value]"
                        :value="op[item.value]"
                        :label="op[item.name]" />
                </el-select>
            </div>
            <template v-else>
                <div
                    class="filter-item"
                    :key="item.key">
                    <div class="label">系统类别：</div>
                    <el-select
                        v-model="categoryId"
                        @change="toUpdateCategory(item)"
                        placeholder="请选择类别"
                        clearable
                        size='small'>
                        <el-option
                            v-for="op in categoryList"
                            :key="op.categoryId"
                            :value="op.categoryId"
                            :label="op.categoryName" />
                    </el-select>
                </div>
                <div
                    class="filter-item"
                    :key="item.key">
                    <div class="label">
                        <span v-if="item.required" class="required">*</span>
                        {{item.label}}：
                    </div>
                    <el-select
                        filterable
                        v-model="filter[item.key]"
                        @change="update(item)"
                        :placeholder="item.placeholder"
                        :clearable="item.required != true"
                        size='small'>
                        <template v-for="op in projectListFilter">
                            <el-option
                                v-if="op.roleAppStatus === 0"
                                :key="op[item.value]"
                                :value="op[item.value]"
                                :label="op[item.name]" />
                            <el-option
                                v-if="op.roleAppStatus === 1 && !isRole"
                                :key="op[item.value]"
                                :value="op[item.value]"
                                :label="op[item.name]" />
                        </template>
                    </el-select>
                </div>
            </template>
        </template>
        <el-button
            size='small'
            :disabled="disabled"
            @click="submit"
            type='danger'>查询</el-button>
    </el-drawer>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import {
    getSystemList
} from '@/api'
export default {
    name: 'search',
    props: {
        searchForm: {
            type: Array,
            default: () => []
        },
        searchData: {
            type: Object,
            default: () => ({})
        },
        data: {
            type: Object,
            default: () => ({})
        },
        //不联动全局子系统
        otherProject: {
            type: Boolean,
            default: false
        },
        isRole: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.filter = this.searchData;
        this.$watch('projectList', val => {
            if (val.length) {
                this.projectListFilter = this.projectList
            }
        })
        this.projectListFilter = this.projectList
    },
    computed: {
        ...mapGetters(['projectId', 'categoryList', 'projectList']),
        disabled() {
            let flag = false
            let data = this.searchForm.filter(item => item.required)
            data.some(item => {
                if (!this.filter[item.key] && this.filter[item.key] !== 0) {
                    flag = true
                    return true
                }
                return false
            })
            return flag
        }
    },
    data() {
        return {
            //查询弹窗
            searchShow: false,
            //筛选条件
            filter: {},
            categoryId: '',
            projectListFilter: []
        }
    },
    methods: {
        //点击查询
        submit() {
            this.$emit('submit', this.filter)

            let hasProject = this.searchData.projectId || (this.searchData.projectId === 0)
            if (hasProject && this.filter.projectId !== this.projectId && !this.otherProject) {
                this.$store.dispatch('changeProjectId', this.filter.projectId);
            }
            this.searchShow = false
        },
        //筛选条件关联
        update(item) {
            if (item.relate) {
                this.filter[item.relateKey] = ''
                this.$emit(item.relateUpdate, this.filter[item.key])
            }
        },
        //远程搜索方法
        remote(query,item) {
            if (item.remote) {
                this.$emit(item.remoteMethod, query)
            }
        },
        //得到焦点重置搜索项
        selectFocus(item) {
            if (item.remote && !this.filter[item.key]) {
                this.$emit(item.remoteMethod, '')
            }
        },
        //切换系统类别
        async toUpdateCategory(item) {
            try {
                if (!this.categoryId && this.categoryId !== 0) {
                    this.projectListFilter = this.projectList
                    return
                }
                let {
                    code,
                    result
                } = await getSystemList({
                    categoryId: this.categoryId
                })
                if (code === 0) {
                    this.projectListFilter = result
                    this.filter.projectId = ''
                    this.update(item)
                }
            } catch (error) {
                console.log(error)
            }
        }
    },
    watch: {
        searchData: {
            deep: true,
            handler(newVal) {
                this.filter = newVal
            }
        },
        projectId(newVal) {
            if (this.filter.projectId !== newVal && !this.otherProject) {
                this.filter.projectId = newVal
            }
        }
    }
}
</script>

<style lang="scss">
.search-drawer {
    .el-drawer__body {
        padding: 0 20px;
    }

    .filter-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .label {
            width: 120px;
            text-align: right;
            padding-right: 10px;
            font-size: 14px;
            color: #606266;

            .required {
                color: #F56C6C;
            }
        }

        .el-input,
        .el-select {
            width: 200px;
        }
    }
}
</style>
